import * as React from "react";
import * as Styled from "./SettingsStyles";
import PageContainer from "@/components/PageContainer";
import { observer } from "mobx-react";

const NewSettings = ({ children }) => {
  return (
    <PageContainer>
      <Styled.SectionContainer>{children}</Styled.SectionContainer>
    </PageContainer>
  );
};

export default observer(NewSettings);
